var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1912_1146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.168 19.8334V17.5C29.168 16.8812 28.9221 16.2877 28.4846 15.8501C28.047 15.4125 27.4535 15.1667 26.8346 15.1667H3.5013C2.88246 15.1667 2.28897 15.4125 1.85139 15.8501C1.4138 16.2877 1.16797 16.8812 1.16797 17.5V31.5C1.16797 32.1189 1.4138 32.7124 1.85139 33.1499C2.28897 33.5875 2.88246 33.8334 3.5013 33.8334H26.8346C27.4535 33.8334 28.047 33.5875 28.4846 33.1499C28.9221 32.7124 29.168 32.1189 29.168 31.5V29.1667M29.168 19.8334H19.8346C18.597 19.8334 17.41 20.325 16.5348 21.2002C15.6596 22.0754 15.168 23.2623 15.168 24.5C15.168 25.7377 15.6596 26.9247 16.5348 27.7999C17.41 28.675 18.597 29.1667 19.8346 29.1667H29.168M29.168 19.8334C30.4056 19.8334 31.5926 20.325 32.4678 21.2002C33.343 22.0754 33.8346 23.2623 33.8346 24.5C33.8346 25.7377 33.343 26.9247 32.4678 27.7999C31.5926 28.675 30.4056 29.1667 29.168 29.1667M8.16797 15.1667V8.16669C8.16797 6.31017 8.90547 4.52969 10.2182 3.21694C11.531 1.90418 13.3115 1.16669 15.168 1.16669C17.0245 1.16669 18.805 1.90418 20.1177 3.21694C21.4305 4.52969 22.168 6.31017 22.168 8.16669V15.1667M28.0013 24.5H30.3346M23.3346 24.5H25.668M18.668 24.5H21.0013",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_1146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordImg);
export default __webpack_public_path__ + "static/media/password_img.48c0d9c8ec55ae5ed97808e40168e04d.svg";
export { ForwardRef as ReactComponent };